import jQuery from "jquery";
import toastr from "toastr";
import swiperCarousel from './swiper_carousels.js';
import select2 from "select2";
import 'bootstrap-front';
import { initSelect2Users, initSelect2BasicAjax } from '../../backend/assets/js/scripts/modules/select2.js'

window.$ = window.jQuery = jQuery;
window.bootstrap = require("bootstrap-front");

(function () {
    'use strict'

    // He metido esto aquí de manera provisional para solucionar el problema del crsf token en los ajax type POST
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    // Constante con la configuración que vamos a utilizar
    // en este desarrollo con JS.
    const FUDEAT = { url : '/front/ajax' , locale : 'es-ES' , country : 'es' , currency : 'EUR' };

    const $UNITS                    = $('[data-fudeat-cart-units]');    // Contante para repercutir las unidades del carrito.
    const $MODAL                    = $('#MODAL');                      // Contante para la MODAL
    const _XHR                      = new window.XMLHttpRequest();      // Contante para abortar los AJAX. IMPORTANTE!!!

    const _SELECT2                  = {
        allowClear:                     false,
        placeholder:                    '...',
        width:                          '100%'
    };

    // Configuración de TOASTR
    toastr.options.debug            = true;
    toastr.options.timeOut          = 30000;
    toastr.options.positionClass    = 'toast-bottom-right';
    toastr.options.progressBar      = true;
    toastr.options.closeMethod      = 'fadeOut';
    toastr.options.closeDuration    = 300;
    toastr.options.closeEasing      = 'swing';
    toastr.options.preventDuplicates = true;

    // Evalua si es una llamada AJAX correcta para nuestro SCOPE.
    function fudeatIsAjaxCall( args ){
        return typeof args == 'object' && typeof args.endpoint != 'undefined';
    }

    // Si el CHECK es correcto comprueba el carrito.
    function fudeatInputCheckedGetCart( _THIS ){
        $('html').addClass( 'loading' );
        let config    = {
            type:        'GET' ,
            data:        { address_id : $( '[data-fudeat-address-input]' , _THIS ).val( ) } ,
            url:         FUDEAT.url + '/checkout/check-address' ,
            dataType:    'json'
        };
        console.info( 'fudeatInputCheckedGetCart => (config) ' , config );
        $.ajax( config )
        .done( function( data , textStatus , jqXHR ){
            console.info( 'fudeatInputCheckedGetCart.done => ( data , textStatus , jqXHR ) ' , data , textStatus , jqXHR );
            // toastr.success( data.success , 'Dirección seleccionada' );
            let $container = $( '[data-fudeat-summary]' );
            if( $container.length > 0 ){
                $container.html( data.cart );
            }
            $('html').removeClass( 'loading' );
        })
        .fail( function( jqXHR , textStatus , errorThrown ){
            console.info( 'fudeatInputCheckedGetCart.fail => ( jqXHR , textStatus , errorThrown , toastr ) ' , jqXHR , textStatus , errorThrown , toastr );
            toastr.error( jqXHR.responseJSON.error , 'Error' );
            setTimeout( function(){
                location.reload( );
            } , 1000 );
        });
        $(this).validateCheckout();
    }

    // Convierte un STRING en formato CamelCase para de este forma incluir dinámicamente las PSEUDOCLASS que realizan las operaciones del DELIVERY.
    String.prototype.toCamelCase = function() {
        return this.replace(/^([A-Z])|[\s-_](\w)/g, function(match, p1, p2, offset) {
            if (p2) return p2.toUpperCase();
            return p1.toLowerCase();
        });
    };

    // Incluye la clase LOADING en el objeto
    $.fn.modalLoading = function( status ) {
        if( status === true ){
            if( !this.hasClass( 'loading' ) ){
                this.addClass( 'loading' );
            }
        } else {
            this.removeClass( 'loading' )
        }
    };

    $.fn.convertNumberCurrency = function( price ){
        $( this ).text( new Intl.NumberFormat( FUDEAT.locale , { style: 'currency' , currency: FUDEAT.currency } ).format( price ) );
    }

    // Devuelve los argumentos del DATA para Fudeat.
    $.fn.fudeatGetArgs = function( ){
        let _args = $( this ).data( 'fudeat-args' );
        // if( typeof _args == 'string' && _args !== '' ){
        //   _args = JSON.parse( _args );
        // }
        return $( this ).data( 'fudeat-args' );
    }

    // Ejecuta el SUCCESS del modal.
    $.fn.ajaxModalDone = function( data , textStatus , jqXHR  ) {
        console.info( 'ajaxModalDone => ( data , textStatus , jqXHR ) ' , data , textStatus , jqXHR );
        var $this    = $( this ),
                params   = $this.data( 'fudeat-params' ),
                selector = params.selector,
                cb       = selector.replace( /[\])}[{(]/g , '' ).replace( /data-/g , '' ).replace( 'fudeat' , 'action' ).toCamelCase( );
        console.info( 'ajaxModalDone => ( params , method , classes[type] ) ' , selector , cb , typeof data.classes );
        if( Array.isArray( data.classes ) && data.classes.length > 0 ){
            $.each( data.classes , function( k , v ){
                $this.addClass( v );
            });
            $this.data( 'fudeat-classes' , data.classes );
        }
        if( typeof data.format != 'undefined' ){
            if( data.format == 'html' ){
                $this.find('[data-bs-fudeat-content]').html( data.success );
                var $selector = $this.find( selector );
                if( $selector.length > 0 ){
                    $selector[cb]();
                }
            }
        }

        if ($('[data-bs-toggle="tooltip"]').length > 0) {
            $('[data-bs-toggle="tooltip"]').tooltip();
        }

        $this.modalLoading( false );
    };

    // Ejecuta el FAIL del modal.
    $.fn.ajaxModalFail = function( jqXHR , textStatus , errorThrown ) {
        console.error( 'ajaxModalFail => ( jqXHR , textStatus , errorThrown , toastr ) ' , jqXHR , textStatus , errorThrown , toastr );
        var $this    = $( this );
        if( typeof jqXHR.responseJSON != 'undefined' && typeof jqXHR.responseJSON.error != 'undefined'  ){
            toastr.error( jqXHR.responseJSON.error , 'Error' );
        }
        // FIX: Prevenimos que la llamada AJAX sea muy rápida.
        setTimeout( function(){
            $this.modal( 'hide' );
        }, 500 );
    };

    // Ejecuta la consulta AJAX del MODAL.
    $.fn.ajaxModal = function( ) {
        var $this  = $( this ),
                data   = $this.data( 'fudeat-params' ),
                config    = {
                    type:        data.type ,
                    data:        data.params ,
                    url:         FUDEAT.url + data.endpoint ,
                    dataType:    'json',
                    xhr:         function(){ return _XHR; }
                };
        console.info( 'ajaxModal => (config) ' , config );
        $.ajax( config ).done( $.proxy( $this.ajaxModalDone , this ) ).fail( $.proxy( $this.ajaxModalFail , this ) );
    };

    // A la hora de abrir el modal, esta function valida si podemos abrir o no el modal segun los argumentos incluidos.
    //$.fn.openModal = function( e ) {
    $.fn.openModal = function( e, args = false ) {
        var $button   = $( e.relatedTarget ),
                $modal    = $( this ),
                //args      = $button.fudeatGetArgs();
                args      = !args ? $button.fudeatGetArgs() : args;

        console.info( 'openModal => ( args ) ' , args );
        console.info( 'openModal => ( args ) ' , args.modal_id );
        console.info( 'openModal => ( args 3 ) ' , args.selector );
        if(args.modal_id && (args.modal_id == 'cart_checkout' || args.modal_id == 'select_phone_customer' || args.modal_id == 'select_account_checkout' || args.modal_id == 'warning_notification_checkout')){
            let _instance = bootstrap.Modal.getInstance( $MODAL[0] );

            _instance._config.backdrop = 'static';
            _instance._config.keyboard = false;
        }

        if(args.selector === '[data-fudeat-payment]'){
            $(".card_number_text").css('visibility', 'hidden');
            $('.card_user_payment_id').val(false);
            $('.card_add_next_step_text').hide();
        }

        if( fudeatIsAjaxCall( args ) ){
            $modal.modalLoading( true );
            if( typeof args.type == 'undefined' ){
                args.type = 'GET';
            }
            $modal.data( 'fudeat-params' , args );
            console.info( 'openModal => ( [data-fudeat-params] ) ' , $modal.data( 'fudeat-params' ) );
            $modal.ajaxModal( );
        } else {
            $modal.modal('hide');
        }
    };

    // Ejecutamos esta función cuando se cierra el modal, restaurando sus valores iniciales.
    //$.fn.closeModal = function( e ) {
    $.fn.closeModal = function( e, hcontent = true ) {
        console.info( 'closeModal => ( e ) ' , e );
        var $this     = $( this ),
                classes   = $this.data( 'fudeat-classes' );
        _XHR.abort( );

        $this.modalLoading( false );
        $this.removeData( 'fudeat-params' );
        $this.removeData( 'fudeat-classes' );
        if( Array.isArray( classes ) && classes.length > 0 ){
            $.each( classes , function( k , v ){
                $this.removeClass( v );
            });
        }
        hcontent ? $this.find( '[data-bs-fudeat-content]' ).html( '' ): '';
    };

    // Para los pasos incluidos en cada Cantina
    $.fn.stepsCanteen = function( ){
        var $this         = $( this ) ,
                _THIS         = this ,
                step          = $this.data( 'fudeat-step' ) ,
                options       = $this.fudeatGetArgs( );

        if( typeof options == 'object' && typeof options.target != 'undefined' ){
            if( options.target == 'input:radio' ){
                $this.on( 'checked' , options.target , function( e ){
                    console.log( 'ON CHECKED 1!!!!' , e );
                    $('html').addClass( 'loading' );
                    deleteSteps( step );
                    let $_this  = $( e.currentTarget ) ,
                            config  = {
                                type:        options.type ,
                                data:        { } ,
                                url:         FUDEAT.url + options.endpoint ,
                                dataType:    'json' ,
                                xhr:         function(){ return _XHR; }
                            };
                    config.data[$_this.attr('name')] = $_this.val( );
                    console.info( 'stepsCanteen:checked => ( config , step ) ' , config , step );
                    setTimeout( function(data , textStatus , jqXHR ){
                        $.ajax( config ).done(
                            $.proxy( ajaxDone , _THIS ),
                            function( data , textStatus , jqXHR ){
                                // Cantina Noche - Logica para cambiar el endpoint de carro y habilitar visualmente el carro en cantina
                                if ($this.data( 'fudeat-step' ) === 1 && data.cart_enabled === 1) {
                                    var args_cart_alternative = $("#getCartButtonElement").attr('data-fudeat-args-alternative');
                                    $("#getCartButtonElement").attr('data-fudeat-args', args_cart_alternative);
                                    $(".cart-canteen").css("display", "block");
                                } else if ($this.data( 'fudeat-step' ) === 1 && data.cart_enabled === 0) {
                                    $(".cart-canteen").css("display", "none");
                                }

                                // Cantina Noche - Auto pulsar el día que se ve en pantalla
                                if ($("#auto_select_this_day button")) {
                                    $("#auto_select_this_day button").click()

                                }
                            }
                            ).fail( $.proxy( ajaxFail , _THIS ) );
                    }, 500);
                });
            }

            if( options.target == 'button' ){
                $this.on( 'click' , options.target , function( e ){
                    $('html').addClass( 'loading' );
                    $this.find('button').removeClass('active');
                    $( this ).addClass( 'active' ).blur( );
                    deleteSteps( step );
                    let $_this  = $( e.currentTarget ) ,
                            config  = {
                                type:        options.type ,
                                data:        { } ,
                                url:         FUDEAT.url + options.endpoint ,
                                dataType:    'json' ,
                                xhr:         function(){ return _XHR; }
                            };
                    if (options.night_detection === true) {
                        var is_night = $(e.currentTarget).val() == 'is_night' ? true : false;
                        config.data['is_night'] = is_night;
                    }
                    config.data['date'] = $( this ).data('fudeat-value');
                    console.info( 'stepsCanteen:click => ( config ) ' , config );
                    $.ajax( config ).done( $.proxy( ajaxDone , _THIS ) ).fail( $.proxy( ajaxFail , _THIS ) );
                });
            }
        }

        function deleteSteps( step ){
            $( '[data-separation]' ).each( function( i , e ){
                if( parseInt( $(e).data('separation') ) > step  ){
                    $(e).removeClass( 'active' );
                }
            });
            $( '[data-fudeat-step]' ).each( function( i , e ){
                if( parseInt( $(e).data('fudeat-step') ) > step  ){
                    $(e).removeClass( 'active' ).html('');
                }
            });
        }

        var ajaxDone = function( data , textStatus , jqXHR ){
            console.info( 'stepsCanteen:ajaxDone => ( data , textStatus , jqXHR ) ' , data , textStatus , jqXHR );
            var $container = $('[data-fudeat-step="' + options.step.toString( ) + '"]');
            var $separation = $('[data-separation="' + options.step.toString( ) + '"]');
            if( $container.length > 0  ){
                $separation.addClass( 'active' );
                $container.html( data.success ).addClass('active');
                if( $('.carousel__item').length > 0 ){
                    swiperCarousel( );
                }
                $('html, body').animate({
                    scrollTop: $container.offset( ).top
                } , 250 );
            }
            $('html').removeClass( 'loading' );
        }

        var ajaxFail = function( jqXHR , textStatus , errorThrown ){
            console.error( 'stepsCanteen:ajaxFail => ( jqXHR , textStatus , errorThrown ) ' , jqXHR , textStatus , errorThrown );
            if( typeof jqXHR.responseJSON != 'undefined' && typeof jqXHR.responseJSON.error != 'undefined'  ){
                toastr.error( jqXHR.responseJSON.error , 'Error' );
            }
            $('html').removeClass( 'loading' );
        }

    }

    // ============
    // PSEUDOCLASES
    // ============

    // PRODUCTO: Lógica de añadir un producto nuevo.
    $.fn.actionProduct = function( ) {

        var $this         = $( this ),
                $groups       = $( '[data-fudeat-group]' , this ),
                $subproducts  = $( '[data-fudeat-subproduct]' , this ),
                $add          = $( '[data-fudeat-add]' , this ),
                $addSubproduct= $( '[data-fudeat-add-subproduct]' , this ),
                $qty          = $( '[data-fudeat-qty]' , this ),
                $qtySubproduct= $( '[data-fudeat-qty-subproduct]' , this ),
                $total        = $( '[data-fudeat-total]' , this ),
                options       = $this.fudeatGetArgs(),
                activeGroupClass = 'is-active',
                qty,
                $button;
        if( options.cart_type == 'canteen' ){
            qty           = 1 ,
            $button       = $( '[type="submit"]' , this );
        } else {
            qty           = parseInt( $qty.val( ) ) ,
            $button       = $total.parent( );
        }

        console.info( 'actionProduct => ( options ) ' , options );

        // Valida los botones de suma/resta para incluir
        // o quitar el atributo de DISABLED.
        function validateADDS( min , max ){
            if( $add.length > 0 ){
                $add.each( function( i , e ){
                    let $_this    = $( e ),
                            _options  = $_this.fudeatGetArgs();
                    if( ( _options.qty > 0 && max == false ) || ( _options.qty < 0 && min == false ) ){
                        $_this.attr( 'disabled' , true );
                    }
                    if( ( _options.qty > 0 && max == true ) || ( _options.qty < 0 && min == true ) ){
                        $_this.prop( 'disabled' , false );
                    }
                });
            }
        }

        // Valida los grupos de selección dentro de un producto.
        function validateGROUPS( ){
            if( $groups.length > 0 ){
                $groups.each( function( i , e ){
                    let $group    = $( e ),
                            _options  = $group.fudeatGetArgs();
                    var qtyTotal = 0;

                    $( '[data-fudeat-qty-subproduct]' , $group ).each( function( i , e ){
                        let $subprod    = $( e ),
                                _optionsSub  = $subprod.fudeatGetArgs();
                        if($subprod.val() != '0'){
                            qtyTotal += parseInt($subprod.val());
                        }

                        var arrayId = $(e).attr('id').split('-');

                        if(parseInt(_options.limit) === 0 && parseInt(_options.limitFrom) === 0 && parseInt(_options.limitTo) === 0){
                            $group.addClass( activeGroupClass );

                            if(_optionsSub.dataLimitFrom === null && _optionsSub.dataLimitTo === null){
                                if($subprod.val() === '0'){
                                    $('#data-fudeat-add-'+arrayId[3]).prop( 'disabled' , false );
                                    $('#data-fudeat-less-'+arrayId[3]).attr( 'disabled' , true );
                                }else{
                                    $('#data-fudeat-less-'+arrayId[3]).prop( 'disabled' , false );
                                    $('#data-fudeat-add-'+arrayId[3]).prop( 'disabled' , false );
                                }
                            }else{
                                if(_optionsSub.dataLimitFrom >= parseInt($subprod.val())){
                                    $('#data-fudeat-less-'+arrayId[3]).attr( 'disabled' , true );
                                }else{
                                    $('#data-fudeat-less-'+arrayId[3]).prop( 'disabled' , false );
                                }
                                if(_optionsSub.dataLimitTo <= parseInt($subprod.val())){
                                    $('#data-fudeat-add-'+arrayId[3]).attr( 'disabled' , true );
                                }else{
                                    $('#data-fudeat-add-'+arrayId[3]).prop( 'disabled' , false );
                                }
                            }
                        }else{
                            if((qtyTotal === parseInt(_options.limit) && parseInt(_options.limitFrom) === 0 && parseInt(_options.limitTo) === 0) || (parseInt(_options.limitTo) === qtyTotal && parseInt(_options.limitTo) != 0)){
                                $group.addClass( activeGroupClass );
                                $( '[data-fudeat-qty-subproduct]' , $group ).each( function( i , e ){
                                    let $subprodBlocked    = $( e )

                                    var arrayIdBlocked = $(e).attr('id').split('-');

                                    if($subprodBlocked.val() === '0'){
                                        $('#data-fudeat-less-'+arrayIdBlocked[3]).attr( 'disabled' , true );
                                        $('#data-fudeat-add-'+arrayIdBlocked[3]).attr( 'disabled' , true );
                                    }else{
                                        $('#data-fudeat-add-'+arrayIdBlocked[3]).attr( 'disabled' , true );
                                        $('#data-fudeat-less-'+arrayIdBlocked[3]).prop( 'disabled' , false );
                                    }
                                });

                            }else{
                                if(_options.limitFrom != 0 && _options.limitTo != 0){
                                    if(_options.limitFrom <= qtyTotal && _options.limitTo >= qtyTotal){
                                        $group.addClass( activeGroupClass );
                                    }else{
                                        $group.removeClass( activeGroupClass);
                                    }
                                } else if(_options.limitFrom == 0 || _options.limitTo == 0) {
                                    if (_options.limitFrom == 0 && _options.limitTo != 0) {
                                        if(_options.limitTo >= qtyTotal){
                                            $group.addClass( activeGroupClass );
                                        }else{
                                            $group.removeClass( activeGroupClass);
                                        }
                                    }
                                    if (_options.limitTo == 0 && _options.limitFrom != 0) {
                                        if(_options.limitFrom <= qtyTotal){
                                            $group.addClass( activeGroupClass );
                                        }else{
                                            $group.removeClass( activeGroupClass);
                                        }
                                    }
                                    if (_options.limitTo == 0 && _options.limitFrom == 0) {
                                        if(_options.limit == qtyTotal){
                                            $group.addClass( activeGroupClass );
                                        }else{
                                            $group.removeClass( activeGroupClass);
                                        }
                                    }
                                } else{
                                    $group.removeClass( activeGroupClass);
                                }

                                $( '[data-fudeat-qty-subproduct]' , $group ).each( function( i , e ){
                                    let $subprodUnBlocked    = $( e ),
                                            _optionsSubUnBlocked  = $subprodUnBlocked.fudeatGetArgs();
                                    var arrayIdUnBlocked = $(e).attr('id').split('-');
                                    if(_optionsSubUnBlocked.dataLimitFrom === null && _optionsSubUnBlocked.dataLimitTo === null){
                                        if($subprodUnBlocked.val() === '0'){
                                            $('#data-fudeat-add-'+arrayIdUnBlocked[3]).prop( 'disabled' , false );
                                            $('#data-fudeat-less-'+arrayIdUnBlocked[3]).attr( 'disabled' , true );
                                        }else{
                                            $('#data-fudeat-less-'+arrayIdUnBlocked[3]).prop( 'disabled' , false );
                                            $('#data-fudeat-add-'+arrayIdUnBlocked[3]).prop( 'disabled' , false );
                                        }
                                    }else{
                                        if(_optionsSub.dataLimitFrom >= parseInt($subprod.val())){
                                            $('#data-fudeat-less-'+arrayId[3]).attr( 'disabled' , true );
                                        }else{
                                            $('#data-fudeat-less-'+arrayId[3]).prop( 'disabled' , false );
                                        }
                                        if(_optionsSub.dataLimitTo <= parseInt($subprod.val())){
                                            $('#data-fudeat-add-'+arrayId[3]).attr( 'disabled' , true );
                                        }else{
                                            $('#data-fudeat-add-'+arrayId[3]).prop( 'disabled' , false );
                                        }
                                    }
                                });
                            }
                        }
                    });
                });
            }
        }

        // Valida que el formulario se pueda enviar. He quitado
        // la validación de cantidades porque entiendo que, cuando
        // aparece el producto, debe incluir la cantidad minima por
        // defecto, y la máxima nunca se sobrepasa.
        function validateFORM( ){
            if( $groups.length > 0 && $groups.filter(':not(.'+activeGroupClass+')').length != 0 ){
                $button.attr( 'disabled' , true );
                return false;
            }
            $button.prop( 'disabled' , false );
            return true;
        }

        // Método para incluir el precio dentro del botón. Al no haber
        // cargado todavía entiendo que es mejor evaluar desde aquí
        // el total.
        function aumont( ){
            let total = qty * parseFloat( options.price );
            if( $subproducts.length > 0 ){
                $subproducts.each( function( i , e ){
                    if( $(e).is(':checked') ){
                        let _options = $(e).fudeatGetArgs();
                        total += qty * parseFloat( _options.price );
                    }
                });
            }

            // Hacemos logica para no mostrar el precio en el detalle del producto de la cantina
            var viewPricesShow = $('#viewPricesDataShow').val();
            var viewPricesImport = parseFloat($('#viewPricesDataImport').val());
            console.log('show & import');
            console.log(viewPricesShow);
            console.log(viewPricesImport);
            console.log('total');
            console.log(total);

            if (viewPricesShow == true) {
                // Se deben de mostrar precios
                console.log('viewPricesShow == true');
                if (viewPricesImport > 0 && $(viewPricesImport).length > 0) {
                    console.log('viewPricesImport > 0');
                    total -= viewPricesImport;
                    // Controlamos que no queden cifras negativas
                    total = total < 0 ? parseFloat(0) : total;
                } else if(viewPricesImport < 1 && !$(viewPricesImport).length ) {
                    // Aqui no hacemos nada
                    console.log('viewPricesImport < 1');
                    total = total
                }
            } else if(viewPricesShow == false) {
                // NO Se deben de mostrar precios
                console.log('viewPricesShow == false');
                total = parseFloat(0);
            }

            $total.text( new Intl.NumberFormat( FUDEAT.locale , { style: 'currency' , currency: FUDEAT.currency } ).format( total ) );
        }

        // Método para incluir el precio dentro del botón. Al no haber
        // cargado todavía entiendo que es mejor evaluar desde aquí
        // el total.

        function aumontSubproduct(){
            let total = qty * parseFloat( options.price );
            if( $addSubproduct.length > 0 ){
                $addSubproduct.each( function( i , e ){
                    var subproductSearch = $(e).fudeatGetArgs().replace(/'/g, '"')
                    const obj = JSON.parse(subproductSearch);
                    if(obj.qty>0){
                        var nombre_qty_id = '#data-fudeat-qty-'+obj.subproductId
                        var $qty_subproduct = $(nombre_qty_id).val()
                        if( $qty_subproduct > 0 ){
                            total = total + ( ($qty_subproduct * parseFloat( obj.price )) * qty);
                        }
                    }
                });
            }

            // Hacemos logica para no mostrar el precio en el detalle del producto de la cantina
            var viewPricesShow = $('#viewPricesDataShow').val();
            var viewPricesImport = parseFloat($('#viewPricesDataImport').val());
            console.log('show & import');
            console.log(viewPricesShow);
            console.log(viewPricesImport);
            console.log('total');
            console.log(total);

            if (viewPricesShow == true) {
                // Se deben de mostrar precios
                console.log('viewPricesShow == true');
                if (viewPricesImport > 0 && $(viewPricesImport).length > 0) {
                    console.log('viewPricesImport > 0');
                    total -= viewPricesImport;
                    // Controlamos que no queden cifras negativas
                    total = total < 0 ? parseFloat(0) : total;
                } else if(viewPricesImport < 1 && !$(viewPricesImport).length ) {
                    // Aqui no hacemos nada
                    console.log('viewPricesImport < 1');
                    total = total
                }
            } else if(viewPricesShow == false) {
                // NO Se deben de mostrar precios
                console.log('viewPricesShow == false');
                total = parseFloat(0);
            }

            $total.text( new Intl.NumberFormat( FUDEAT.locale , { style: 'currency' , currency: FUDEAT.currency } ).format( total ) );
        }

        // Ejecutado por los CHECKBOX de los subproductos a
        // seleccionar en los grupos. Valida el grupo, y aumenta el
        // precio, como que valida tambien el formulario.
        let _check = function( e ){
            validateGROUPS( );
            aumont( );
            validateFORM( );
        }

        // Evento de los botones de más y menos. Lo unico que hace
        // es sumar o restar el input de texto, que es el encargado
        // de la lógica.
        let _qty = function( e ){
            e.preventDefault();
            let $_this    = $( this ),
                    _options  = $_this.fudeatGetArgs();
            $MODAL.modalLoading( true );
            $qty.val( qty + _options.qty );
            $qty.trigger( 'input' );
        }

        // Evento de los botones de más y menos. Lo unico que hace
        // es sumar o restar el input de texto, que es el encargado
        // de la lógica.
        let _qty_subproduct = function( e ){
            e.preventDefault();
            let $_this    = $( this ),
            _options  = $_this.fudeatGetArgs();
            var subproductSearch = _options.replace(/'/g, '"')
            const obj = JSON.parse(subproductSearch);
            var nombre_qty_id = '#data-fudeat-qty-'+obj.subproductId
            var $qty_subproduct = $(nombre_qty_id)
            $MODAL.modalLoading( true );
            $qty_subproduct.val( parseInt($(nombre_qty_id).val()) + parseInt(obj.qty) );
            $qty_subproduct.trigger( 'input' );
            validateGROUPS();
            aumontSubproduct();
            validateFORM( );
        }

        // Una vez el usuario incluye un número, este será enviado
        // a validar. Si todo va bien se incluye como cantidad válida
        // si va mal, se vuelve a incluir el valor inicial antes del cambio.
        let _inputQTY = function( e ){
            e.preventDefault( );
            let $_this      = $( this ),
                    _options    = $_this.fudeatGetArgs( ),
                    _qty_new    = parseInt( $_this.val( ) ) ,
                    _qty_old    = qty;
            if( !Number.isInteger( _qty_new ) || isNaN( _qty_new ) ){
                $_this.val( _qty_old );
                e.preventDefault( );
                return false;
            }
            $MODAL.modalLoading( true );
            var config    = {
                type:        _options.type ,
                data: {
                    'quantity':    _qty_new ,
                    'product_id':  options.product_id ,
                } ,
                url:         FUDEAT.url + _options.endpoint ,
                dataType:    'json',
                xhr:         function( ){ return _XHR; }
            };
            console.info( 'actionProduct._inputQTY => (config) ' , config );
            $.ajax( config )
            .done( function( data , textStatus , jqXHR ){
                console.info( 'actionProduct._inputQTY.done => ( data , textStatus , jqXHR ) ' , data , textStatus , jqXHR );
                qty = parseInt( data.quantity );
                $_this.val( qty );
                validateADDS( data.min , data.max );
                aumont( );
                aumontSubproduct( );
                $MODAL.modalLoading( false );
            })
            .fail( function( jqXHR , textStatus , errorThrown ){
                console.info( 'actionProduct._inputQTY.fail => ( jqXHR , textStatus , errorThrown , toastr ) ' , jqXHR , textStatus , errorThrown );
                toastr.error( jqXHR.responseJSON.error , 'Error' );
                $_this.val( _qty_old );
                $MODAL.modalLoading( false );
            });
        }

        // Una vez el usuario incluye un número, este será enviado
        // a validar. Si todo va bien se incluye como cantidad válida
        // si va mal, se vuelve a incluir el valor inicial antes del cambio.
        let _inputQTYSubproduct = function( e ){
            let $_this      = $( this ),
                    _options    = $_this.fudeatGetArgs( ),
                    _qty_new    = parseInt( $_this.val( ) )
            var nombre_qty_id = '#data-fudeat-qty-'+_options.params.subproductId
            let _qty_old    = $qtySubproduct.val( )
            if( !Number.isInteger( _qty_new ) || isNaN( _qty_new ) ){
                $(nombre_qty_id).val(_qty_old);
                e.preventDefault( );
                return false;
            }
            $MODAL.modalLoading( true );
            var config    = {
                type:        _options.type ,
                data: {
                    'quantity':    _qty_new ,
                    'subproduct_id':  _options.params.subproductId ,
                } ,
                url:         FUDEAT.url + _options.endpoint ,
                dataType:    'json',
                xhr:         function( ){ return _XHR; }
            };
            console.info( 'actionProduct._inputQTYSubproduct => (config) ' , config );
            $.ajax( config )
            .done( function( data , textStatus , jqXHR ){
                console.info( 'actionProduct._inputQTY.done => ( data , textStatus , jqXHR ) ' , data , textStatus , jqXHR );
                $MODAL.modalLoading( false );
            })
            .fail( function( jqXHR , textStatus , errorThrown ){
                console.info( 'actionProduct._inputQTY.fail => ( jqXHR , textStatus , errorThrown , toastr ) ' , jqXHR , textStatus , errorThrown );
                toastr.error( jqXHR.responseJSON.error , 'Error' );
                $(nombre_qty_id).val(_qty_old);
                $MODAL.modalLoading( false );
            });
        }

        // Realiza el envío al carrito de la compra.
        let _submit = function( e ){
            e.preventDefault();
            if( !validateFORM( ) ){
                return false;
            }
            $MODAL.modalLoading( true );
            let config    = {
                type:        $this.attr( 'type' ) ,
                data:        $this.serialize( ) ,
                url:         FUDEAT.url + $this.attr( 'action' ) ,
                dataType:    'json',
                xhr:         function( ){ return _XHR; }
            };
            console.info( 'actionProduct._submit => (config) ' , config );
            $.ajax( config )
            .done( function( data , textStatus , jqXHR ){
                console.info( 'actionProduct.done => ( data , textStatus , jqXHR ) ' , data , textStatus , jqXHR );
                console.log( 'esto es data de la modal' , data);
                toastr.success( data.success , 'Producto añadido' );
                if( typeof options == 'object' && options.cart_type == 'canteen'){
                    var cart_enable = parseFloat($('#cart_enabled').val());
                    if(cart_enable === 1){
                        $UNITS.text( data.cart_items );
                    }else{
                        if( data.canteen == true ){
                            setTimeout( function(){
                                location.href = data.url;
                            } , 400 );
                        }
                    }
                } else {
                    $UNITS.text( data.cart_items );

                    // Logica para abrir la pagina de proveedor después de añadir un producto
                    var urlpageprovider = $this.attr( 'urlpageprovider' );
                    if (urlpageprovider && urlpageprovider !== 'none') {
                        window.location.href = urlpageprovider;
                    }
                }
                $MODAL.modal( 'hide' );
            })
            .fail( function( jqXHR , textStatus , errorThrown ){
                console.info( 'actionProduct.fail => ( jqXHR , textStatus , errorThrown , toastr ) ' , jqXHR , textStatus , errorThrown , toastr );
                toastr.error( jqXHR.responseJSON.error , 'Error' );
                $MODAL.modalLoading( false );
            });
        }

        validateGROUPS( );
        validateADDS( options.min , options.max );
        aumont( );
        validateFORM( );

        if( $addSubproduct.length > 0 ){
            $addSubproduct.on( 'click' , _qty_subproduct );
        }
        if( $qtySubproduct.length > 0 ){
            $qtySubproduct.on( 'input' , _inputQTYSubproduct );
        }
        if( $add.length > 0 ){
            $add.on( 'click' , _qty );
        }
        if( $qty.length > 0 ){
            $qty.on( 'input' , _inputQTY );
        }

        $( this ).on( 'submit' , _submit );

    };

    // CARRITO: Lógica del carrito.
    $.fn.actionCart = function( ) {

        var $this         = $( this ),
                $products     = $( '[data-fudeat-products] [data-fudeat-product]' , this ),
                $extras       = $( '[data-fudeat-extras]' , this ),
                $subtotal     = $( '[data-fudeat-subtotal]' , this ),
                $freeTransport = $( '[data-fudeat-freetransport]' , this ),
                $discount     = $( '[data-fudeat-discount]' , this ),
                $shipping     = $( '[data-fudeat-shipping]' , this ),
                $feeService     = $( '[data-fudeat-fee-service]' , this ),
                $taxes        = $( '[data-fudeat-taxes]' , this ),
                $total        = $( '[data-fudeat-total]' , this ),
                options       = $this.fudeatGetArgs( ),
                templateTax   = '<div class="cart__item__actions cart__item__actions_black h6" data-fudeat-taxes-container><p data-fudeat-taxes-name></p><p data-fudeat-taxes-price></p></div>';

        // Valida los botones de suma/resta para incluir
        // o quitar el atributo de DISABLED.
        function validateADDS( min , max , $product ){
            if( $product.find('[data-fudeat-add]').length > 0 ){
                $product.find('[data-fudeat-add]').each( function( i , e ){
                    let $_this    = $( e ),
                            _options  = $_this.fudeatGetArgs();
                    if( ( _options.qty > 0 && max == false ) || ( _options.qty < 0 && min == false ) ){
                        $_this.attr( 'disabled' , true );
                    }
                    if( ( _options.qty > 0 && max == true ) || ( _options.qty < 0 && min == true ) ){
                        $_this.prop( 'disabled' , false );
                    }
                });
            }
        }

        // Actualiza el precio de los elementos del
        // carrito. Los parciales, los totales, y las
        // taxes.
        function updatePrices( $this , data ){

            if(data.freeTransport != null)
            {
                $freeTransport.parents('.cart__total_delivery').fadeIn();
                $freeTransport.html(data.freeTransport);
            }
            else
            {
                $freeTransport.parents('.cart__total_delivery').fadeOut();
            }

            $this.find('[data-fudeat-price]').convertNumberCurrency( data.price );
            $subtotal.convertNumberCurrency( data.subtotal );
            $shipping.convertNumberCurrency( data.shipping );
            $feeService.convertNumberCurrency( data.fee_service );
            if( $taxes.length > 0 ){
                let $taxContainer = $taxes.find( '[data-fudeat-taxes-container]' );
                if( $taxContainer.length > 0 ){
                    $taxContainer.remove( );
                }
                if( typeof data.taxes === 'object' && Object.keys( data.taxes ).length > 0 ){
                    $.each( data.taxes , function( i , e ){
                        let $taxContainer = $( templateTax );
                        $taxContainer.find('[data-fudeat-taxes-name]').text( e.name );
                        $taxContainer.find('[data-fudeat-taxes-price]').convertNumberCurrency( e.totalTax );
                        $taxes.append( $taxContainer );
                    });
                    $taxes.show( );
                } else {
                    $taxes.hide( );
                }
            }
            if( $discount.length > 0 ){
                if( typeof data.discount != 'undefined' ){
                    $discount.show( ).find('[data-fudeat-taxes-price]').convertNumberCurrency( data.discount );
                } else {
                    $discount.hide( );
                }
            } else {
                if( typeof data.discount != 'undefined' ){
                    $discount.find('[data-fudeat-taxes-price]').convertNumberCurrency( data.discount );
                    $discount.show( );
                }
            }
            $total.convertNumberCurrency( data.total );
        }

        // Evento de los botones de más y menos. Lo unico que hace
        // es sumar o restar el input de texto, que es el encargado
        // de la lógica. Ojo que lo utilizamos tambien para
        // el borrado del producto.
        let _qty = function( e ){
            e.preventDefault();
            let $_this    = $( this ),
                    $_input   = $_this.parents('[data-fudeat-product]').find('[data-fudeat-qty]'),
                    _qty      = parseInt( $_input.val( ) ),
                    _options  = $_this.fudeatGetArgs();
            $MODAL.modalLoading( true );
            $_input.val( _options.qty == 0 ? _options.qty : _qty + _options.qty );
            $_input.trigger( 'input' );
        }

        // Una vez el usuario incluye un número, este será enviado
        // a validar. Si todo va bien se incluye como cantidad válida
        // y si es 0 se borra, y si no, se incluye la cantidad
        // modificando los precios.
        let _inputQTY = function( e ){
            let $_this      = $( this ) ,
                    $_product   = $_this.parents('[data-fudeat-product]'),
                    _options    = $_this.fudeatGetArgs( ) ,
                    _qty_new    = parseInt( $_this.val( ) ) ,
                    _qty_old    = parseInt( $_product.find('[data-fudeat-qty-value]').text( ) );

            if( !Number.isInteger( _qty_new ) || isNaN( _qty_new ) ){
                e.preventDefault( );
                $_this.val( _qty_old );
                return false;
            }

            $MODAL.modalLoading( true );
            var config    = {
                type:        _options.type ,
                data: {
                    'quantity':   _qty_new ,
                } ,
                url:         FUDEAT.url + _options.endpoint ,
                dataType:    'json',
                xhr:         function( ){ return _XHR; }
            };
            if( typeof _options.product_id != 'undefined' ){
                config.data.product_id = _options.product_id;
                config.data.id_combination_attribute = _options.id_combination_attribute;
            }
            if( typeof _options.extra_id != 'undefined' ){
                config.data.extra_id = _options.extra_id;
            }
            console.info( 'actionCart._inputQTY => (config) ' , config );
            $.ajax( config )
            .done( function( data , textStatus , jqXHR ){
                console.info( 'actionCart._inputQTY.done => ( data , textStatus , jqXHR ) ' , data , textStatus , jqXHR );
                toastr.success( data.success , 'Carrito actualizado' );
                $UNITS.text( data.cart_items );
                if( data.cart_items == 0 ){
                    $MODAL.modal( 'hide' );
                } else {
                    if( data.quantity <= 0 && typeof _options.product_id != 'undefined' ){
                        $_product.fadeOut( 500 , function(){
                            $( this ).remove();
                        });
                    } else {
                        $_product.find('[data-fudeat-qty-value]').text( data.quantity );
                        $_product.find('[data-fudeat-total-base-price]').text( data.total_base_price );
                        // Esto es para hacer el calculo de los totales de subproducto del carro
                        var subproductsTotals = data.subproducts_totals;

                        if (subproductsTotals) {
                            Object.entries(subproductsTotals).forEach(subproduct => {
                                const [key, value] = subproduct;
                                var totalForSubproduct = '+' + value + ' €';
                                $_product.find('[data-fudeat-total-subproduct-'+key+']').text( totalForSubproduct );
                            });
                        }

                        if( typeof _options.product_id != 'undefined' ){
                            validateADDS( data.min , data.max , $_product );
                        }

                        if( typeof _options.extra_id != 'undefined' ){
                            if(_qty_new === 0){
                                validateADDS( false , true , $_product );
                            }else{
                                validateADDS( true , true , $_product );
                            }
                        }

                    }
                     updatePrices( $_product , data );
                    /* if( typeof data.extras != 'undefined' ){
                        $extras.html( data.extras );
                    } */
                    $MODAL.modalLoading( false );
                }
            })
            .fail( function( jqXHR , textStatus , errorThrown ){
                console.info( 'actionCart._inputQTY.fail => ( jqXHR , textStatus , errorThrown , toastr ) ' , jqXHR , textStatus , errorThrown );
                toastr.error( jqXHR.responseJSON.error , 'Error' );
                $_this.val( _qty_old );
                $MODAL.modalLoading( false );
            });

        }

        // Este método aplica al CHECK de los extras, relizando el
        // endpoint conveniente a cada caso.
        let _check = function( e ){
            let $_this      = $( this ) ,
                    $_product   = $_this.parents('[data-fudeat-product]'),
                    _options    = $_this.fudeatGetArgs( );

            $MODAL.modalLoading( true );
            var config    = {
                type:        _options.type ,
                data: {
                    'extra_id':   _options.extra_id ,
                    'status':     $_this.is( ':checked' ) ,
                } ,
                url:         FUDEAT.url + _options.endpoint ,
                dataType:    'json',
                xhr:         function( ){ return _XHR; }
            };
            console.info( 'actionCart._check => (config) ' , config );
            $.ajax( config )
            .done( function( data , textStatus , jqXHR ){
                console.info( 'actionCart._check.done => ( data , textStatus , jqXHR ) ' , data , textStatus , jqXHR );
                toastr.success( data.success , 'Carrito actualizado' );
                $UNITS.text( data.cart_items );
                $_product.find('[data-fudeat-qty-value]').text( data.quantity );
                updatePrices( $_product , data );
                $MODAL.modalLoading( false );
            })
            .fail( function( jqXHR , textStatus , errorThrown ){
                console.info( 'actionCart._check.fail => ( jqXHR , textStatus , errorThrown , toastr ) ' , jqXHR , textStatus , errorThrown );
                toastr.error( jqXHR.responseJSON.error , 'Error' );
                $MODAL.modalLoading( false );
            });
        }

        // Validación previa a la carga del modal.
        $products.each( function( i , e ){
            let $_this    = $( e ),
                    _options  = $_this.fudeatGetArgs( );
            console.info('.........', _options)
            console.info(_options)
            validateADDS( _options.min , _options.max , $_this );
        });


        // Validación previa a la carga del modal.
        $extras.each( function( i , e ){
            let $_this    = $( e ),
                    _options  = $_this.fudeatGetArgs( );
            if( typeof _options != 'undefined'){
                if(_options.quantity != 0){
                    validateADDS( true , true , $_this );
                }else{
                    validateADDS( false , true , $_this );
                }
            }
        });

        $this.on( 'click' , '[data-fudeat-add]' , _qty );
        $this.on( 'input' , '[data-fudeat-qty]' , _inputQTY );
        $this.on( 'change' , '[data-fudeat-extra]' , _check );

    }

    var $payment_card = false;

    // CHECKOUT: Lógica del formulario de direcciones.
    $.fn.actionAddress = function( ) {

        var $this          = $( this ),
                isDelivery     = $this.is('[data-fudeat-delivery]'),
                $confirm       = $('[data-fudeat-checkout-confirm]'),
                $select2       = $( '.select2' , this ),
                $select2State  = $( '[data-select2state]' , this );

        if( $select2.length > 0 ){
            $select2.select2( $.extend( {} , _SELECT2 , { dropdownParent : $this } ) );

        }

        if($select2State.length > 0)
        {
            $select2State.dataselect2state( $.extend( {} , _SELECT2 , { dropdownParent : $this } ) );
        }

        // Valida el formulario.
        function validateFORM( ){
            if( isDelivery ){
                if( $this.find('[data-fudeat-address-input]:checked').length > 0 ){
                    $confirm.prop( 'disabled' , false );
                } else {
                    $confirm.attr( 'disabled' , true );
                }
            }
        }

        let _submit = function( e ){
            e.preventDefault();
            $MODAL.modalLoading( true );

            //if($payment_card === false){
                let config    = {
                    type:        $this.attr( 'type' ) ,
                    data:        $this.serialize( ) ,
                    url:         FUDEAT.url + $this.attr( 'action' ) ,
                    dataType:    'json',
                    xhr:         function( ){ return _XHR; }
                };
                console.info( 'actionAddress._submit => (config) ' , config );
                $.ajax( config )
                .done( function( data , textStatus , jqXHR ){
                    console.info( 'actionAddress.done => ( data , textStatus , jqXHR ) ' , data , textStatus , jqXHR );
                    if(data.error != undefined){
                        toastr.error( data.error , 'Error al guardar la dirección' );
                        $MODAL.modalLoading( false );
                    }else{
                        toastr.success( data.success , 'Dirección añadida' );
                        let $container = $('[data-fudeat-'+data.type+']');
                        if( $container.length > 0 ){
                            if( typeof data.address_id == 'undefined' ){
                                    let $last = $container.find('[data-fudeat-address]'); // David
                                    let $colContainer = $container.find('[data-fudeat-addresses]'); // David
                                if( $last.length > 0 ){
                                    $colContainer.find('[data-fudeat-address]').parent().last().after( data.address ); // Fer

                                    var addressRecentlyAdded = $colContainer.find('[data-fudeat-address]').parent().last();
                                    var addressRecentlyAddedObteined = addressRecentlyAdded.find('input[name="delivery_address_id"]');
                                    var addressRecentlyAddedObteinedId = addressRecentlyAdded.find('input[name="delivery_address_id"]').val();

                                    addressRecentlyAddedObteined.removeAttr('checked');
                                    $('[data-fudeat-address-id='+addressRecentlyAddedObteinedId+']').removeClass('active_card');
                                    $('[data-fudeat-address-id='+addressRecentlyAddedObteinedId+']').trigger( 'click' );

                                    //$colContainer.find('[data-fudeat-address]').parent().last().trigger( 'click' ); // Fer
                                } else {
                                    $colContainer.prepend( data.address ); // David
                                }
                            } else {
                                let $item = $container.find('[data-fudeat-address-id="' + data.address_id.toString() + '"]');
                                if( typeof data.address == 'undefined' ){
                                    if( $item.hasClass( 'active_card' ) ){
                                        $container.find('[data-fudeat-address]').first( ).trigger( 'click' );
                                    }
                                    $item.fadeOut( 500 , function(){
                                        $( this ).parent().remove();
                                    });
                                } else {
                                    $item.parent().replaceWith( data.address );
                                    $container.find('[data-fudeat-address-id="' + data.address_id.toString() + '"]').trigger( 'click' );
                                }
                            }
                        }
                        validateFORM( );
                        $MODAL.modal( 'hide' );
                    }
                })
                .fail( function( jqXHR , textStatus , errorThrown ){
                    console.info( 'actionAddress.fail => ( jqXHR , textStatus , errorThrown , toastr ) ' , jqXHR , textStatus , errorThrown , toastr );
                    toastr.error( jqXHR.responseJSON.error , 'Error' );
                    $MODAL.modal( 'hide' );
                });
            /* }else{
                addCreditCard($this);
            } */
        }

        $( this ).on( 'submit' , _submit );

        validateFORM( );

    }

    // CHECKOUT: Lógica del formulario de tipo de cuenta.
    $.fn.actionCorporate = function( ) { }


    // CHECKOUT: Validate checkout for enabled button to buy
    $.fn.validateCheckout = function( ){
        let $deliveryAddressChecked = $('.checkout [data-fudeat-delivery]').find('[data-fudeat-address-input]:checked')
        let $paymentMethodChecked = $('.checkout .payment_method_data').find('[name="payment_method"]:checked')

        console.info($deliveryAddressChecked)

        if($deliveryAddressChecked.length > 0 && $paymentMethodChecked.length > 0){
            $('.checkout [data-fudeat-checkout-confirm]').attr('disabled', false)
        }else{
            $('.checkout [data-fudeat-checkout-confirm]').attr('disabled', true)
        }
    }

    var cardNumberId = '';

    function validateCheckout() {
        let $deliveryAddressChecked = $('.checkout [data-fudeat-delivery]').find('[data-fudeat-address-input]:checked')
        let $paymentMethodChecked = $('.checkout .payment_method_data').find('[name="payment_method"]:checked')

        console.info($deliveryAddressChecked)

        if($deliveryAddressChecked.length > 0 && $paymentMethodChecked.length > 0){
            $('.checkout [data-fudeat-checkout-confirm]').attr('disabled', false)
        }else{
            $('.checkout [data-fudeat-checkout-confirm]').attr('disabled', true)
        }

        if($(cardNumberId).text() === ''){
            $('.card_number_text').hide();
            $('.card_add_next_step_text').hide();
            $('.card_user_payment_id').val(false);
        }
    }

    // EVENTOS: Para el modal.
    $( document ).on( 'show.bs.modal' , '#MODAL' , $.proxy( $MODAL.openModal , this ) );
    $( document ).on( 'hidden.bs.modal' , '#MODAL' , $.proxy( $MODAL.closeModal , this ) );

    $( document ).on( 'click' , '[data-fudeat-addresses] .card_controls' , function( e ){ e.stopPropagation(); } );

    $( document ).on( 'click' , '[data-fudeat-addresses] .general_card:not(.add_address_card), [data-fudeat-canteens] .general_card:not(.add_address_card)' , function( e ) {
        e.preventDefault();
        if( ! $(this).hasClass( 'active_card' ) ){
            let $parent = $( this ).is('[data-fudeat-canteen]') ? $( this ).parents( '[data-fudeat-canteens]' ) : $( this ).parents( '[data-fudeat-addresses]' );
            $parent.find( '.general_card' ).each( function( i , e ){
                $( e ).removeClass( 'active_card' );
                $( 'input:radio' , e ).prop( 'checked' , false );
                $( 'input:radio' , e ).attr( 'checked' , false );
                $( 'input:radio' , e ).removeAttr( 'checked' );
            });
            $( 'input:radio' , this ).prop( 'checked' , true );
            $( 'input:radio' , this ).attr( 'checked' , 'checked' );
            $( 'input:radio' , this ).trigger( 'checked' );
            $( this ).addClass('active_card');

            if( $parent.parent().is('[data-fudeat-delivery]') && $parent.parent().is('[data-fudeat-check-address]') ){
                fudeatInputCheckedGetCart( this );
                $(this).validateCheckout();
            }
        }
    });

    $( document ).on( 'click' , '.general_card.payment_card ' , function( e ) {
        e.preventDefault();
        if( ! $(this).hasClass( 'active_card' ) ){
            $('.general_card.payment_card').each( function( i , e ){
                $( e ).removeClass( 'active_card' );
                $( 'input:radio' , e ).prop( 'checked' , false );
                $( 'input:radio' , e ).attr( 'checked' , false );
                $( 'input:radio' , e ).removeAttr( 'checked' );
            });
            $( 'input:radio' , this ).prop( 'checked' , true );
            $( 'input:radio' , this ).attr( 'checked' , 'checked' );
            $( this ).addClass('active_card');
        }
    });

    $( document ).on( 'click' , '.card__item__header_list' , function( e ) {
        $('.payment_card_list').attr('disabled', false);
    });

    $( document ).on( 'click' , '.payment_card_list' , function( e ) {
        e.preventDefault();
        $('.card_user_payment_id').val($('input:radio[name=card_id]:checked').val());
        $('.card_number_text').css('visibility','visible');
        cardNumberId = '#card_number_'+$('input:radio[name=card_id]:checked').val();
        $('.card_number').html($(cardNumberId).text());
        $('.card_add_next_step_text').hide();
        $('.card_number_text').show();
    });

    $( document ).on( 'click' , '.card__item_list' , function( e ) {
        e.preventDefault();
        $( 'input:radio' , this ).prop( 'checked' , true );
    });

    $( document ).on( 'click' , '.modal-delete' , function( e ) {
        $MODAL.modalLoading( true );
        console.info( 'deleteCreditCard._submit => (config) ' , $(this).attr("value") );

        $.ajax({
            url: FUDEAT.url + '/checkout/delete-card',
            type:"POST",
            data:{
                payment_user_id: $(this).attr("value"),
            },
            success:function(response) {
                console.log('esto es respuesta', response);

                var $container = $('[data-fudeat-payment-user]');
                $container.html(response.success);
                $MODAL.modalLoading( false );
            },
            error: function(error) {
                console.info( 'Error delete card' , error);
                toastr.error( error , 'Error' );
                $MODAL.modal( 'hide' );
            }
        });

    });

    $( document ).on( 'click' , '#payment_card_button' , function( e ) {
        $('.card_user_payment_id').val(true);
        $('.card_add_next_step_text').show();
        $('.card_number_text').hide();
    });

    $( document ).on( 'click' , '[data-fudeat-addresses] .card_controls' , function( e ){ e.stopPropagation(); } );

    $( document ).on( 'click' , '[data-fudeat-addresses]' , function( e ){
        e.stopPropagation();
    } );

    $( document ).on( 'change' , '.checkout [data-fudeat-delivery] [data-fudeat-address-input]' , function( e ) {
        //$(this).validateCheckout();
        validateCheckout();
    })

    $( document ).on( 'change' , '.checkout .payment_method_data [name="payment_method"]' , function( e ) {
        //$(this).validateCheckout();
        validateCheckout();
    })

    var selectBuyOrder = initSelect2BasicAjax('#checkout', '.select2-buyorder', false, '/back/ajaxAutocompleteBuyOrderCompany', {
        allowClear: false,
        placeholder: "Por favor, selecciona un elemento del listado",
    })

    $('[data-fudeat-step]').each( function( i , e ){
        $( e ).stepsCanteen( );
    });

    $('.checkout_data .confirm_button button').on('click', function(event, ui) {
        setTimeout( function(){
            $('.checkout [data-fudeat-checkout-confirm]').attr('disabled', true);
        } , 5 );
    });


    const $typeAccount = $('[data-fudeat-type-account]');

    if( $typeAccount.length > 0 ){
        setTimeout( function(){
            $MODAL.modal('show' , $typeAccount );
        } , 1000 );
    }

    const $checkPhoneAccount = $('[data-fudeat-check-phone-account]');

    if( $checkPhoneAccount.length > 0 ){
        setTimeout( function(){
            $MODAL.modal('show' , $checkPhoneAccount );
        } , 1000 );
    }

    window.addEventListener("scroll", function () {
        if ($(this).scrollTop() > 10) {
            $(".header__wrapper").addClass("bg-header");
        } else {
            $(".header__wrapper").removeClass("bg-header");
        }
    });
})()
